export function requiredValidation(value) {
  if (!value) {
    return 'This field is required';
  }

  return undefined;
}

export function minLengthValidation(value) {
  if (value && value.length < 70) {
    return 'You must enter at least 70 characters';
  }

  return undefined;
}

export function emailValidation(value) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    return undefined;
  }

  return 'Please enter a valid email';
}

export function composeValidators(...validators) {
  return (value) => validators.reduce((error, validator) => error || validator(value), undefined);
}
